


































































































import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {getCalculators, get, getPdf} from '../../services/webclient/webclient';
import {translate} from "../../services/translation/translation";
import './_calc-selector-page.less';
import $ from 'jquery';
import {number} from "prop-types";
import {goToTop} from "@/services/position/position";

@Component({})

export default class CalcSelectorPage extends Vue {
    private calculators: any = {
        facade: [1],
        interior: [1],
        exterior: [1],
        facadeHover: false,
        interiorHover: false,
        exteriorHover: false
    };

    activated() {
        goToTop('', 'calc-selector');
        try {
            $('.grid').masonry();
        }
        catch (ex) { }
    }


    mounted() {
        goToTop('', 'calc-selector');
        getCalculators().then(data => {
            this.calculators.facade = data.calculators.facade;
            this.calculators.interior = data.calculators.interior;
            this.calculators.exterior = data.calculators.exterior;
        }).catch(err => console.warn(err));

    }

    toogle(key, value = -1){
        if(value == -1){
            this.calculators[key] = !this.calculators[key];
        }else{
            this.calculators[key] = value;
        }
    }

    selectCalc(calc) {
        this.selectedCalc(calc.id);
        this.onSelectCalcName(calc.name);
    }


    get Calcs() {
        return this.calculators;
    }

    trans(key) {
        return translate(key);
    }


    @Emit("selectedCalc")
    selectedCalc(id) {
    }

    @Emit("selectCalcName")
    onSelectCalcName(name) {
    }
}

